import { useLocation } from "react-router-dom";
import { isAndroidDevice } from "../Helpers/Utilities";
import { PAGE_ROUTES } from "../Helpers/Enums";

const AndroidRouteGuard = ({ children }) => {
  const location = useLocation();
  const isAndroid = isAndroidDevice();
  const allowedRoute =
    location.pathname === "/" ||
    location.pathname === PAGE_ROUTES.COURSE_CONSOLIDATION;

  if (isAndroid && !allowedRoute) {
    return (
      <h2 style={{ textAlign: "center" }}>
        This website is currently not supported on Android devices.
      </h2>
    );
  }

  return <>{children}</>;
};

export default AndroidRouteGuard;
